import { useSelector } from 'react-redux';

const useVonAuthentication = () => {
    const user = useSelector((state) => state.CommonReducer.user);

    return user?.isSignedInToVon || false;
};

export default useVonAuthentication;
